import { gql } from '@apollo/client';

// Operation name `SendSurveyResponse` is deliberately distinct from the backend
// field `submitSurveyResponse` (and its `SubmitSurveyResponseMutation` payload
// type) — equal names collapse the generated result type (graphql-codegen skill).
// `value` inside SurveyAnswerInput is a JSONString: the typed answer is
// JSON.stringify-ed in core/hooks/Surveys, never in components (spec 0011 §6).
export const SendSurveyResponseMutation = gql`
  mutation SendSurveyResponse($assignmentId: ID!, $answers: [SurveyAnswerInput!]!) {
    submitSurveyResponse(assignmentId: $assignmentId, answers: $answers) {
      success
      customErrors {
        code
        field
        message
      }
    }
  }
`;
